(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);
    handleTransitionCancellation(viewTransition);

    if (shouldSkipViewTransition(viewTransition, event)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          try {
            viewTransition.skipTransition();
          } catch (_) {}
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      if (setTransitionType(viewTransition, transitionType)) {
        sessionStorage.setItem('custom-transition-type', transitionType);
      }
    } else {
      setTransitionType(viewTransition, 'page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);
    handleTransitionCancellation(viewTransition);

    if (shouldSkipViewTransition(viewTransition, event)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      setTransitionType(viewTransition, customTransitionType);

      try {
        await viewTransition.finished;
      } catch (_) {}

      setTransitionType(viewTransition, 'page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      setTransitionType(viewTransition, 'page-navigation');
    }

  });

  /** @param {ViewTransition | null} viewTransition */
  function handleTransitionCancellation(viewTransition) {
    // The outgoing document and skipTransition can reject ready before pagereveal.
    viewTransition?.ready.catch(() => {});
    viewTransition?.finished.catch(() => {});
  }

  /**
   * @param {ViewTransition | null} viewTransition
   * @param {PageSwapEvent | PageRevealEvent} [event]
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition, event) {
    return !viewTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice() || isRecommenderNavigation(event) || isCheckoutNavigation(event) || isProductArrival(event);
  }

  // Entering a product should not add a second movement to its ready header.
  // Other destinations retain their existing page transition.
  function isProductArrival(event) {
    const rawUrl = event?.type === 'pageswap' ? event.activation?.entry?.url : window.location.href;
    if (!rawUrl) return false;
    try { return /(?:^|\/)products\/[^/]+/.test(new URL(rawUrl, window.location.origin).pathname); }
    catch (_) { return false; }
  }

  function isCheckoutNavigation(event) {
    const rawUrl = event?.activation?.entry?.url;
    if (!rawUrl) return false;
    try {
      return /^\/checkouts?(?:\/|$)/.test(new URL(rawUrl, window.location.origin).pathname);
    } catch (_) {
      return false;
    }
  }

  function isRecommenderNavigation(event) {
    if (document.body?.classList?.contains('template-page-recomendador')) return true;
    const urls = [
      window.location.href,
      event?.activation?.entry?.url,
      event?.activation?.from?.url,
    ];
    return urls.some((rawUrl) => {
      try {
        const path = new URL(rawUrl, window.location.origin).pathname.replace(/\/+$/, '');
        return path === '/pages/recomendador';
      } catch (_) {
        return false;
      }
    });
  }

  function setTransitionType(viewTransition, transitionType) {
    try {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      return true;
    } catch (_) {
      return false;
    }
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. */
    /* eslint-disable-next-line compat/compat */
    return (
      window.__btmcLowPerf === true ||
      document.documentElement.classList.contains('btmc-low-end-device') ||
      (Number(navigator.hardwareConcurrency) > 0 && Number(navigator.hardwareConcurrency) <= 2 &&
        Number(navigator.deviceMemory) > 0 && Number(navigator.deviceMemory) <= 2)
    );
  }
})();
